import React, {useEffect, useState} from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {HeaderAnswerComponent} from "../PanelContents/HeaderAnswer";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ZooPassLocalStateData from "../../Data/ZooPassLocalStateData";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";
import HeaderAnswerTranslationItem from "../../Data/HeaderAnswerTranslationItem";
import ZooPassAnswerAvailabilityUtility from "../../Utilities/ZooPassAnswerAvailabilityUtility";
import classNames from 'classnames';

export const Step5Panel: React.FC = () => {
    let {
        headerAnswers,
        textTitles,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading,
        updateContext
    } = useZooPassAppAnswersContext();
    
    const handleRadioClick = (radioValue: null | 0 | 1 | 2 | 3 | 4) =>
    {
        if(answersData == null) return;
        answersData.step5Value = radioValue;
        answersData.previousStep = answersData.step;
        answersData.step = 7;
        ZooPassLocalStateUtility.SetLocalState(answersData);
        updateContext({type: "setAnswers", value: answersData});
    };

    const handleOptionKeyPress = (event : any, value : null | 0 | 1 | 2 | 3 | 4) => {
        if(!event.altKey && !event.metaKey && !event.shiftKey && event.key === 'Enter') {
            handleRadioClick(value);
        }
    }

    if(!answersLoading && !loading && textTitles !== null && headerAnswers !== null && answersData !== null)
    {
        const available = ZooPassAnswerAvailabilityUtility.CalculateGuestOptionAvailability(answersData);
        return answersData.step == 5 && (
                <div className="container d-block">
                    <StepTitleContent textTitle={textTitles.get("ZooPass:PageContent:05")}/>
                    <div className={classNames(
                        'row',
                        'g-4',
                        'g-lg-3',
                        'g-xl-2',
                        {'g-xl-2': available.options.length <= 4},
                        {'g-xl-4': available.options.length === 5},
                        'mx-auto',
                        'justify-content-center',
                        'row-cols-1',
                        'row-cols-md-2',
                        'row-cols-lg-2',
                        {'row-cols-xl-4': available.options.length <= 4},
                        {'row-cols-xl-3': available.options.length === 5}
                    )}>
                        <HeaderAnswerComponent headerAnswerData={headerAnswers.get("ZooPass:PageAnswer:05:0")}
                                               onKeyPressEnter={(event) => handleOptionKeyPress(event, 0)}
                                               nameValue="step5" onClick={() => handleRadioClick(0)} shouldShow={available.options.includes(0)} key="radio0"/>
                        <HeaderAnswerComponent headerAnswerData={headerAnswers.get("ZooPass:PageAnswer:05:1")}
                                               onKeyPressEnter={(event) => handleOptionKeyPress(event, 1)}
                                               nameValue="step5" onClick={() => handleRadioClick(1)} shouldShow={available.options.includes(1)} key="radio1"/>
                        <HeaderAnswerComponent headerAnswerData={headerAnswers.get("ZooPass:PageAnswer:05:2")}
                                               onKeyPressEnter={(event) => handleOptionKeyPress(event, 2)}
                                               nameValue="step5" onClick={() => handleRadioClick(2)} shouldShow={available.options.includes(2)} key="radio2"/>
                        <HeaderAnswerComponent headerAnswerData={headerAnswers.get("ZooPass:PageAnswer:05:3")}
                                               onKeyPressEnter={(event) => handleOptionKeyPress(event, 3)}
                                               nameValue="step5" onClick={() => handleRadioClick(3)} shouldShow={available.options.includes(3)} key="radio3"/>
                        <HeaderAnswerComponent headerAnswerData={headerAnswers.get("ZooPass:PageAnswer:05:4")}
                                               onKeyPressEnter={(event) => handleOptionKeyPress(event, 4)}
                                               nameValue="step5" onClick={() => handleRadioClick(4)} shouldShow={available.options.includes(4)} key="radio4"/>
                    </div>
                </div>
        );
    }
    
    
};

